import React from "react";
import Navigation from "../components/Navigation";
import NavigationBottom from "../components/NavigationBottom";

function Main({ menuVisible, toggleMenu }) {
    if (!menuVisible) return null;

    return (
        <>
            {/* Backdrop — desktop only */}
            <div
                onClick={toggleMenu}
                className="fixed inset-0 bg-black/50 z-[100] hidden md:block"
            />

            {/* Drawer — no scroll, fixed height = full screen */}
            <div className="
                fixed top-0 left-0 z-[1000]
                w-[320px] max-md:w-full h-full
                bg-white flex flex-col overflow-hidden
                rounded-r-2xl max-md:rounded-none
                shadow-[4px_0_32px_rgba(0,0,0,0.14)]
            ">
                {/* Navigation takes all remaining space */}
                <div className="flex-1 overflow-hidden flex flex-col">
                    <Navigation onClose={toggleMenu} />
                </div>

                {/* Footer is always pinned to bottom */}
                <NavigationBottom />
            </div>
        </>
    );
}

export default Main;
